import { useState, useCallback, useEffect } from 'react';
import { Pagination, SelectItemProps } from '@ui/src';
import { useLazyGetMonitoringRulesQuery } from '../store/service';
import { TransactionMonitoringRule } from '../types';

interface ListResponse {
  data: {
    data: {
      edges: { node: TransactionMonitoringRule }[];
      pageInfo: Pagination;
    };
  };
}

const useGetAutocompleteList = () => {
  const [autocompleteList, setAutocompleteList] = useState<SelectItemProps[]>(
    [],
  );

  const [pagination, setPagination] = useState<Pagination | undefined>(
    undefined,
  );
  const [nextPageIsLoading, setNextPageIsLoading] = useState(false);
  const [selectedList, setSelectedList] = useState<SelectItemProps[]>([]);
  const [getList, { isFetching, isLoading }] = useLazyGetMonitoringRulesQuery();

  const getAutocompleteListAction = useCallback(
    async (cursor?: string, list?: SelectItemProps[]) => {
      let results: SelectItemProps[] = [];

      if (cursor && list) {
        results = ([] as SelectItemProps[]).concat(list);
        setNextPageIsLoading(true);
      }

      const response = (await getList(
        cursor ? `&cursor=${cursor}` : '',
      )) as ListResponse;

      if (response?.data?.data) {
        response.data.data.edges?.forEach((item) => {
          if (
            !results.find((resultItem) => resultItem.value === item.node.id)
          ) {
            results.push({
              name: item.node.name,
              value: item.node.id,
            });
          }
        });

        setPagination(response?.data?.data?.pageInfo);
        setNextPageIsLoading(false);
      }

      setAutocompleteList(results);
    },
    [],
  );

  const onScroll = () => {
    getAutocompleteListAction(pagination?.endCursor, autocompleteList);
  };

  useEffect(() => {
    getAutocompleteListAction();
  }, [getAutocompleteListAction]);

  return {
    autocompleteList,
    monitoringRulesIsLoading: isLoading || isFetching,
    onScroll,
    nextPageIsLoading,
    setSelectedList,
    selectedList,
    pagination,
  };
};

export default useGetAutocompleteList;
